// This file is automatically generated. Do not edit manually.

import { ProjectActivity } from "src/api/generated/erp/db/types/tables/projectActivity";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectActivityApi {
	export async function getSingleActivity(args: {
		activityId: number;
	}): Promise<ProjectActivity> {
		const response = await makeAxiosRequest({
			url: "/api/ext/projects/getSingleActivity",
			method: "POST",
			data: {
				activityId: args.activityId,
			},
		});
		return response as ProjectActivity;
	}
}
